import React, { useState } from "react";
import MoreInfoPopup from "./MoreInfoPopup";
import { useNavigate } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const undergraduatePerks = [
  {
    img: "/SAPImages/pricing/profile.png",
    perk: "Profile Evaluation",
  },
  {
    img: "/SAPImages/pricing/universityshortlist.png",
    perk: "University Shortlisting",
  },
  {
    img: "/SAPImages/pricing/testprep.png",
    perk: "Test Preparation",
  },
  {
    img: "/SAPImages/pricing/timeline.png",
    perk: "Application Strategy & Timeline",
  },
  {
    img: "/SAPImages/pricing/sop.png",
    perk: "SOP & Essays",
  },
  {
    img: "/SAPImages/pricing/cv.png",
    perk: "CV/Resume",
  },
  {
    img: "/SAPImages/pricing/lor.png",
    perk: "LOR Guidance",
  },
  {
    img: "/SAPImages/pricing/schorlarship.png",
    perk: "Scholarships & Financial Aid",
  },
  {
    img: "/SAPImages/pricing/video.png",
    perk: "Mock Interviews & Video Essays",
  },
  {
    img: "/SAPImages/pricing/visa.png",
    perk: "Visa & Pre-Departure",
  },
];

const postgraduatePerks = [
  {
    img: "/SAPImages/pricing/universityshortlist.png",
    perk: "University Shortlistingzz",
  },
  {
    img: "/SAPImages/pricing/lor.png",
    perk: "LOR Guidance",
  },
  {
    img: "/SAPImages/pricing/sop.png",
    perk: "Essay Drafting",
  },
  {
    img: "/SAPImages/pricing/schorlarship.png",
    perk: "Scholarships & Financial Aid",
  },
  {
    img: "/SAPImages/pricing/video.png",
    perk: "Mock Interviews & Video Essays",
  },
  {
    img: "/SAPImages/pricing/visa.png",
    perk: "Visa & Pre-Departure",
  },
];

function PackageCard({
  package_name,
  original_price,
  sub_service_id,
  installments,
  id,
  scholars_program_id,
  currency,
  is_enrolled,
}) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [openAccordian, setOpenAccordian] = useState(false);

  const hasPayments = installments.length > 0;

  return (
    <div
      style={{
        // height: "auto",
        borderRadius: "10px",
        background: "#FFFFFF",
        boxShadow: "0px 0px 8px 0px #00000033",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
      }}
    >
      {/* Header: Image + Package Name */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          marginBottom: "12px",
        }}
      >
        <img
          src="/SAPImages/pricing/Group 1171283405.png"
          alt={package_name}
          style={{
            width: "44px",
            height: "45px",
            objectFit: "contain",
          }}
        />
        <span
          style={{
            fontFamily: "Inter",
            fontWeight: 700,
            fontSize: "14px",
            lineHeight: "100%",
            color: "#000",
          }}
        >
          {package_name}
        </span>
      </div>

      {/* Price */}
      <h2
        style={{
          fontFamily: "Inter",
          fontWeight: 700,
          fontStyle: "bold",
          fontSize: "24px",
          lineHeight: "100%",
          letterSpacing: "0",
          color: "#572575",
          margin: "0 0 12px 0",
        }}
      >
        INR {original_price}
      </h2>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "12px",
        }}
      >
        <img
          src="/SAPImages/pricing/Ellipse 9242.png"
          alt="perk icon"
          style={{
            width: "8px",
            height: "8px",
            objectFit: "contain",
          }}
        />

        <h2
          style={{
            fontFamily: "Inter",
            fontWeight: 700,
            fontStyle: "bold",
            fontSize: "12px",
            lineHeight: "100%",
            letterSpacing: "0",
            color: "#9D0385",
            margin: 0,
          }}
        >
          {sub_service_id == 13
            ? "Scholars Undergraduate Admissions Program"
            : "Scholars Postgraduate Admissions Program"}
        </h2>
      </div>

      <div
        style={{
          width: "100%",
          height: "1px",
          backgroundColor: "#E0E0E0",
          margin: "12px 0",
          borderRadius: "2px",
        }}
      ></div>

      {/* Perks */}
      <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
        {/* Title Row */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            marginBottom: "8px",
          }}
        >
          <img
            src="/SAPImages/pricing/Group 1171283408 (8).png"
            alt="Perks icon"
            style={{
              width: "24px",
              height: "24px",
              objectFit: "contain",
            }}
          />
          <span
            style={{
              fontFamily: "Inter",
              fontWeight: 700,
              fontSize: "14px",
              lineHeight: "100%",
              letterSpacing: "0%",
              verticalAlign: "middle",
              background:
                "linear-gradient(140.36deg, #B32A9E 16.86%, #8230B3 84.11%), linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2))",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              opacity: 1,
            }}
          >
            Perks
          </span>
        </div>

        {/* Perks List */}
        {(sub_service_id == 13
          ? undergraduatePerks
          : sub_service_id == 14
            ? postgraduatePerks
            : []
        )
          .slice(0, 4)
          .map((perk, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              <img
                src="/SAPImages/pricing/Vector.png"
                alt="perk icon"
                style={{
                  width: "28px",
                  height: "28px",
                  objectFit: "contain",
                }}
              />
              <span
                style={{
                  fontFamily: "Inter",
                  fontWeight: 400,
                  fontSize: "12px",
                  lineHeight: "100%",
                  color: "#333",
                }}
              >
                {perk.perk}
              </span>
            </div>
          ))}
      </div>

      <div
        style={{
          width: "100%",
          height: "1px",
          backgroundColor: "#E0E0E0",
          margin: "12px 0",
          borderRadius: "2px",
        }}
      ></div>

      <div className="border border-[#F1E5F8] rounded-[10px] p-4 bg-white flex flex-col gap-3">
        {/* Header */}
        <div
          className="flex items-center justify-between w-full cursor-pointer"
          onClick={() => setOpenAccordian(!openAccordian)}
        >
          <div className="flex items-center gap-2">
            <img
              src="/SAPImages/pricing/Group 1171283409 (2).png"
              alt="Payments icon"
              className="w-6 h-6 object-contain"
            />
            <span className="font-altisunisa font-bold text-sm bg-gradient-to-r from-[#B32A9E] to-[#8230B3] bg-clip-text text-transparent">
              {hasPayments ? "Flexible Payments" : "No Flexible Payments"}
            </span>
          </div>

          {hasPayments && (
            <div>
              {openAccordian ? (
                <ChevronUp className="w-5 h-5 text-gray-600" />
              ) : (
                <ChevronDown className="w-5 h-5 text-gray-600" />
              )}
            </div>
          )}
        </div>

        {/* Accordion Content */}
        {openAccordian && hasPayments && (
          <div className="flex flex-wrap gap-3 mt-2">
            {installments.map((inst, index) => {
              const amount = inst[`installment_${index + 1}_amount`];
              const suffixes = ["st", "nd", "rd"];
              const suffix = suffixes[index] || "th";
              const label = `${index + 1}${suffix} Installment`;

              return (
                <div
                  key={index}
                  className="rounded-md bg-white shadow-[0_2px_4px_0_#C5B1DF] flex flex-col items-center justify-center px-3 py-2"
                >
                  <span className="font-altisunisa font-bold text-[11px] bg-gradient-to-r from-[#B32A9E] to-[#8230B3] bg-clip-text text-transparent mb-0.5">
                    INR {amount}
                  </span>
                  <span className="font-altisunisa font-normal text-[11px] text-[#666]">
                    {label}
                  </span>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* Buttons */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "16px",
        }}
      >
        {/* More Info Button */}
        <button
          style={{
            flex: 1,
            marginRight: "8px",
            padding: "10px",
            borderRadius: "8px",
            border: "1px solid #E7CEF6",
            background: "#FFFFFF",
            boxShadow: "0px 2px 4px 0px #F4D3ED",
            color: "#572575",
            fontFamily: "Inter",
            fontWeight: 700,
            fontSize: "14px",
            cursor: "pointer",
            position: "relative",
          }}
          onClick={() => setOpen(true)}
          onMouseEnter={(e) => {
            const tooltip = document.createElement("div");
            tooltip.textContent = "Click to view details";
            tooltip.style.position = "fixed";
            tooltip.style.background = "#572575";
            tooltip.style.color = "#fff";
            tooltip.style.padding = "4px 8px";
            tooltip.style.borderRadius = "6px";
            tooltip.style.fontSize = "12px";
            tooltip.style.whiteSpace = "nowrap";
            tooltip.style.pointerEvents = "none";
            tooltip.style.zIndex = "9999";
            tooltip.style.transition = "opacity 0.2s";
            tooltip.style.opacity = "0";
            document.body.appendChild(tooltip);

            const rect = e.currentTarget.getBoundingClientRect();
            tooltip.style.left =
              rect.left + rect.width / 2 - tooltip.offsetWidth / 2 + "px";
            tooltip.style.top = rect.top - 30 + "px";
            requestAnimationFrame(() => (tooltip.style.opacity = "1"));
            e.currentTarget._tooltip = tooltip;
          }}
          onMouseLeave={(e) => {
            const tooltip = e.currentTarget._tooltip;
            if (tooltip) {
              tooltip.remove();
              e.currentTarget._tooltip = null;
            }
          }}
        >
          More Info
        </button>

        {/* Enroll Button */}
        <button
          style={{
            flex: 1,
            marginLeft: "8px",
            padding: "10px",
            borderRadius: "8px",
            border: "none",
            background: is_enrolled === 1 ? "#9472a8ff" : "#572575",
            color: "#FFF",
            fontFamily: "Inter",
            fontWeight: 700,
            fontSize: "14px",
            cursor: is_enrolled === 1 ? "not-allowed" : "pointer",
            opacity: is_enrolled === 1 ? 0.7 : 1,
            position: "relative",
          }}
          onClick={(e) => {
            // Remove tooltip on click
            if (e.currentTarget._tooltip) {
              e.currentTarget._tooltip.remove();
              e.currentTarget._tooltip = null;
            }

            if (is_enrolled !== 1) {
              navigate("/sap/checkout", {
                state: {
                  package_name,
                  original_price,
                  sub_service_id,
                  installments,
                  id,
                  scholars_program_id,
                  currency,
                },
              });
            }
          }}
          onMouseEnter={(e) => {
            const tooltip = document.createElement("div");
            tooltip.textContent =
              is_enrolled === 1
                ? "You are already enrolled"
                : "Click to enroll in this program";
            tooltip.style.position = "fixed";
            tooltip.style.background = "#572575";
            tooltip.style.color = "#fff";
            tooltip.style.padding = "4px 8px";
            tooltip.style.borderRadius = "6px";
            tooltip.style.fontSize = "12px";
            tooltip.style.whiteSpace = "nowrap";
            tooltip.style.pointerEvents = "none";
            tooltip.style.zIndex = "9999";
            tooltip.style.transition = "opacity 0.2s";
            tooltip.style.opacity = "0";
            document.body.appendChild(tooltip);

            const rect = e.currentTarget.getBoundingClientRect();
            tooltip.style.left =
              rect.left + rect.width / 2 - tooltip.offsetWidth / 2 + "px";
            tooltip.style.top = rect.top - 30 + "px";
            requestAnimationFrame(() => (tooltip.style.opacity = "1"));
            e.currentTarget._tooltip = tooltip;
          }}
          onMouseLeave={(e) => {
            const tooltip = e.currentTarget._tooltip;
            if (tooltip) {
              tooltip.remove();
              e.currentTarget._tooltip = null;
            }
          }}
        >
          Enroll Now
        </button>
      </div>

      <MoreInfoPopup
        open={open}
        onClose={() => setOpen(false)}
        pkg={{
          package_name,
          original_price,
          sub_service_id,
          installments,
          is_enrolled,
        }}
      />
    </div>
  );
}

export default PackageCard;
